module.exports = __webpack_public_path__ + "static/media/elis.809e3bfd.png";